module.exports = __webpack_public_path__ + "static/media/image_1.dbe5ffc9.png";